export default __webpack_public_path__ + "static/media/notify.4d70300b.mp3";